module.exports = __webpack_public_path__ + "static/media/C1.041a4134.png";